import * as Yup from 'yup';

export const initialValues = {
    escalationAndCaseHandling: [{ value: '' }],
};

export const validationSchema = Yup.object().shape({
    escalationAndCaseHandling: Yup.array().of(
        Yup.object().shape({
            value: Yup.string().required('Requerido'),
        })
    ),
});
